// Initialize Lenis, GSAP, and ScrollTrigger
let lenis;

document.addEventListener('DOMContentLoaded', function () {
  // Scroll to top immediately when DOM content loads
  window.scrollTo(0, 0);
  if (document.documentElement) {
    document.documentElement.scrollTop = 0;
  }
  if (document.body) {
    document.body.scrollTop = 0;
  }

  // Register GSAP ScrollTrigger plugin
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

 // Lenis breaks native position:sticky (transform-based scroll). Skip on blog articles (TOC sidebar).
    const skipLenis = document.body.classList.contains('template-article');
    // Lenis smooth scroll with proper configuration
    if (typeof Lenis !== 'undefined' && !skipLenis) {
      lenis = new Lenis({
        duration: 1.4,
        easing: (t) => {
          // Smooth ease-out-quad - gentler deceleration to prevent jerky stops
          // This creates a smooth, natural-feeling deceleration without sudden stops
          return 1 - (1 - t) * (1 - t);
        },
        smoothWheel: true,
        wheelMultiplier: 1,
        smoothTouch: false,
        touchMultiplier: 2,
        infinite: false,
        autoResize: true,
        normalizeWheel: true,
        wrapper: window, // Use window as wrapper to prevent double scrollbar
        prevent: (node) => {
          if (!node || !node.closest) return false;
          return !!node.closest(
            'quick-add-modal, .quick-add-modal__content, [data-variant-popup-dialog]:not([hidden]), cart-drawer, details-modal'
          );
        },
      });
      window.lenis = lenis;

      // Single rAF: Lenis → ScrollTrigger → zigzag (so pin state is current when updating image position)
      function raf(time) {
        lenis.raf(time);
        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.update();
        }
        // Run slideshow image position after ScrollTrigger so product-info/qualities pin state is correct (fixes stuck when scrolling down)
        if (typeof window.updateZigzagPosition === 'function') {
          window.updateZigzagPosition();
        }
        requestAnimationFrame(raf);
      }
      requestAnimationFrame(raf);

      // Simple approach: Hide scrollbar, overflow visible, max-width 100%
      const style = document.createElement('style');
      style.id = 'lenis-scrollbar-hide';
      style.textContent = `
        /* Hide scrollbar but keep scrolling */
        body::-webkit-scrollbar {
          display: none !important;
        }
        body {
          -ms-overflow-style: none !important;
          scrollbar-width: none !important;
        }
        /* Simple: overflow visible for sections, max-width 100% — exclude modals */
        body:not(.quick-add-modal-open) .shopify-section,
        body:not(.quick-add-modal-open) section,
        body:not(.quick-add-modal-open) .section {
          max-width: 100% !important;
          overflow: visible !important;
        }
        quick-add-modal .quick-add-modal__content {
          overflow-y: auto !important;
          -webkit-overflow-scrolling: touch !important;
          touch-action: pan-y !important;
        }
        quick-add-modal .quick-add-modal__content-info {
          overflow: visible !important;
          height: auto !important;
        }
        /* Ensure slideshow image container appears above product-info and qualities */
        .slideshow__image-container {
          z-index: 999999 !important;
          position: fixed !important;
          isolation: isolate !important;
          /* Force it above all sections - create new stacking context at root level */
        }
        /* Lower z-index for product-info and qualities to ensure image appears above */
        /* Don't use position: relative !important on .qualities - ScrollTrigger pins it and needs to set position: fixed */
        /* Scope to page only — not inside quick-add / variant popups (breaks modal scroll) */
        body:not(.quick-add-modal-open) .product-info,
        body:not(.quick-add-modal-open) .qualities {
          z-index: 1 !important;
          overflow: visible !important;
          isolation: auto !important;
          transform: none !important;
        }
        /* Ensure product-info and qualities containers don't trap fixed elements */
        body:not(.quick-add-modal-open) .product-info__container,
        body:not(.quick-add-modal-open) .qualities__container {
          z-index: auto !important;
          overflow: visible !important;
          isolation: auto !important;
          transform: none !important;
        }
        /* .qualities__content-wrapper: overflow set in qualities.css (hidden for block animation) */
        /* Don't override product-info__content transform - GSAP needs it for animation */
        body:not(.quick-add-modal-open) .product-info__content {
          z-index: auto !important;
          overflow: visible !important;
          isolation: auto !important;
          /* Don't set transform: none - let GSAP control it for animation */
        }
        /* Ensure sections and their containers don't clip the fixed image */
        body:not(.quick-add-modal-open) .product-info,
        body:not(.quick-add-modal-open) .product-info__container,
        body:not(.quick-add-modal-open) .qualities,
        body:not(.quick-add-modal-open) .qualities__container {
          overflow: visible !important;
          /* Ensure they don't create stacking contexts that trap fixed elements */
          transform: none !important;
          opacity: 1 !important;
          isolation: auto !important;
        }
        /* Ensure slideshow image is always on top */
        .slideshow__image {
          z-index: 999999 !important;
          isolation: isolate !important;
        }
        /* Prevent horizontal overflow on body/html */
        html,
        body {
          max-width: 100% !important;
          overflow-x: hidden !important;
        }
      `;
      document.head.appendChild(style);

      // Update on window resize - debounce and double-refresh so layout below 990px is correct
      let resizeTimeout;
      window.addEventListener('resize', () => {
        lenis.resize();
        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.refresh();
        }
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          lenis.resize();
          if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.refresh();
          }
          if (typeof window.updateZigzagPosition === 'function') {
            window.updateZigzagPosition();
          }
        }, 150);
      });

      // Ensure Lenis updates after all content is loaded
      window.addEventListener('load', () => {
        lenis.resize();
        if (typeof ScrollTrigger !== 'undefined') {
          ScrollTrigger.refresh();
        }
        // Scroll to top on load
        lenis.scrollTo(0, { immediate: true });
      });

      // Recalculate heights after layout settle (deferred to avoid blocking scroll when user has already scrolled to product-info)
      setTimeout(() => {
        document.body.style.height = 'auto';
        document.documentElement.style.height = 'auto';
        // Defer refresh/resize to next frame so we don't block scroll or reset position
        requestAnimationFrame(() => {
          if (typeof ScrollTrigger !== 'undefined') {
            ScrollTrigger.refresh();
          }
          lenis.resize();
          // Do not scrollTo(0) here - user may have scrolled to product-info; would cause "scroll stops then starts"
        });
      }, 1500);
    }
  }
});

// Scroll to top on pageshow (handles back/forward navigation)
window.addEventListener('pageshow', function (event) {
  if (lenis) {
    lenis.scrollTo(0, { immediate: true });
  } else {
    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }
  
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.refresh();
  }
});
